import { configureHyraxApp } from './config';
import { initPostHog } from './integrations/posthog';

const launch = async () => {
  // Configure globals + identity BEFORE importing the app
  await configureHyraxApp();

  // Boot PostHog before App so route-change autocapture sees the first
  // page-view. No-ops when VITE_POSTHOG_PROJECT_KEY is unset.
  initPostHog();

  // Dynamic import — runs after globals are set
  const { default: App } = await import('./App');
  const { createRoot } = await import('react-dom/client');

  const root = document.getElementById('root');
  if (!root) throw new Error('#root element not found');
  createRoot(root).render(<App />);
};

launch();
